export default {
	en: {
		add: 'Add',
		remove: 'Remove',
		save: 'Save',
		print: 'Print',
		search: 'Search',
		close: 'Close',
		gware:'Groupware',
		haksa:'Academic Information System',
		rms:'Yonsei Researcher Management System(RMS)',
		yri:'Yonsei Researcher Information System(YRI)',
	},
	ko: {
		add: '추가',
		remove: '삭제',
		save: '저장',
		print: '인쇄',
		search: '검색',
		close: '닫기',
		gware:'그룹웨어시스템',
		haksa:'학사정보시스템',
		rms:'연구관리시스템(RMS)',
		yri:'연구업적시스템(YRI)',
	}
}